
// © 2025 Camp Promethean, LLC. All Rights Reserved.
import { ReactElement } from "react";

export type DashboardTool = {
  id: string;
  name: string;
  description: string;
  icon: React.ElementType;
  path: string;
  requiredTier: 'free' | 'Basic' | 'Advanced' | 'Professional';
};

export type DashboardModule = {
  id: string;
  name: string;
  description: string;
  icon: React.ElementType;
  path: string;
  requiredTier: 'free' | 'Basic' | 'Advanced' | 'Professional';
  tools?: DashboardTool[];
  /** Visible on the home dashboard only for platform admins. */
  adminOnly?: boolean;
  /** Shown to all users with a Coming Soon overlay until launch (routes stay admin-only). */
  comingSoon?: boolean;
};

export const MEMBERSHIP_TIERS = {
  'free': 0,
  'Basic': 1,
  'Advanced': 2,
  'Professional': 3
};
